import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Table
} from 'reactstrap';
const v = require("voca");
import $ from "jquery";
import { inject, observer } from "mobx-react";
import { MakeForm } from "common-import/custom";

const propStringRequired = [
  "name", "address", "city", "country", "district", "phone", "email", "taxCode", "origination", "foundedYear"
];
const propArrayRequired = [
  "typeOfContractor", "typeOfConstruction"
];
const propString = [
  "fax", "website", "description", "qualityManagement", "language", "numberOfEmployees", "revenue", "unitRevenue", "price", "unitPrice", "prizes"
];
const propImageUrl = [
  "logo", "wallImage"
];


@inject("contractorStore", "languageStore", "fieldStore", "userStore") @observer
class ImportContractors extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contractor: {}
    };
  }

  renderMutipleImport = () => {
    return (
      <Row>
        <Col xs="12" md="12">
          <Card>
            <CardHeader>
              <i className="fa fa-envelope-open"></i> Create multiple contractors - Upload files (Chưa chạy)
              </CardHeader>
            <CardBody>
              <Form action="" method="post" className="form-horizontal">
                <FormGroup row>
                  <Col md="12">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <Button type="button" color="primary"><i className="fa fa-file"></i> Upload</Button>
                      </InputGroupAddon>
                      <Input type="text" id="input1-group2" name="input1-group2" placeholder="File path .xlsx .csv" />
                    </InputGroup>
                  </Col>
                </FormGroup>
              </Form>
              <CardFooter>
                <Button type="submit" size="sm" color="success"><i className="fa fa-dot-circle-o"></i> Submit</Button>
                <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Reset</Button>
              </CardFooter>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    const { fieldStore } = this.props;
    const { toSelectData, contractor_company_type, contractor_type, contractor_construction_type, project_type } = fieldStore
    const importTemp1 = [
      { name: "name", label: "Tên nhà thầu", type: "string", isRequired: true },
      { name: "type", label: "Cá nhân hay Công ty?", type: "string select", isRequired: false, selectData: [{ alue: "company", title: "Công ty" }, { value: "user", title: "Cá nhân" }] },
      { name: "phone", label: "Số điện thoại", type: "string", isRequired: true },
      { name: "address", label: "Địa chỉ", type: "string", isRequired: true },
      { name: "city", label: "Thành phố", type: "string", isRequired: true },
      { name: "district", label: "Quận", type: "string", isRequired: true },
      { name: "country", label: "Quốc gia", type: "string", isRequired: true },
      { name: "fax", label: "Fax", type: "string", isRequired: false },
      { name: "website", label: "Website", type: "string", isRequired: false },
      { name: "email", label: "Email", type: "string", isRequired: true },
      { name: "taxCode", label: "Mã doanh nghiệp - Tax Code", type: "string", isRequired: true },
      { name: "origination", label: "Nguồn gốc - Origination", type: "string", isRequired: true },
      { name: "foundedYear", label: "Năm thành lập", type: "number", isRequired: true },
      { name: "description", label: "Mô tả", type: "string", isRequired: false },
      { name: "verifyDocuments", label: "Tài liệu xác thực - VerifyDocuments", type: "array upload", urlType: "image", isRequired: false },

      // { name: "documents", label: "Documents", type: "array upload", urlType:"file", isRequired: false },
      // { name: "finances", label: "Finances", type: "array upload", urlType:"file", isRequired: false },
      // { name: "imageFinances", label: "ImageFinances", type: "array upload", urlType:"image", isRequired: false },
      // { name: "status", label: "Trạng thái", type: "string", isRequired: false },
      // { name: "investmentType", label: "Investment Type", type: "string", isRequired: false },
      // { name: "minContructionArea", label: "Min Contruction Area", type: "number", isRequired: false },
      // { name: "maxContructionArea", label: "Max Contruction Area", type: "number", isRequired: false },
      // { name: "minLandArea", label: "Min Land Area", type: "number", isRequired: false },
      // { name: "maxLandArea", label: "Max Land Area", type: "number", isRequired: false },
      // { name: "totalFloorArea", label: "Total Floor Area", type: "number", isRequired: false },
      // { name: "state", label: "State", type: "string", isRequired: false },
      // { name: "purpose", label: "Purpose", type: "string", isRequired: false },
      // { dateName: ["minStartTime", "maxStartTime"], label: "Khoảng thời gian bắt đầu", type: "date duration", isRequired: false },
      // { dateName: ["minFinishTime", "maxFinishTime"], label: "Khoảng thời gian kết thúc", type: "date duration", isRequired: false },
      // { name: "listImages", label: "Hình ảnh", type: "array upload", urlType: "image", isRequired: false }
    ];

    const importTemp2 = [
      { name: "wallImage", label: "Ảnh cover", type: "string upload", urlType: "image cover", isRequired: false },
      { name: "logo", label: "Logo", type: "string upload", urlType: "image", isRequired: false },
      { name: "typeOfCompany", label: "Loại công ty", type: "string select", selectData: toSelectData(contractor_company_type), isRequired: false },
      { name: "numberOfEmployees", label: "Số nhân viên", type: "string", isRequired: false },
      { name: "revenue", label: "Revenue", type: "number", isRequired: false },
      { name: "unitRevenue", label: "UnitRevenue", type: "string", isRequired: false },
      { name: "unitRevenue", label: "UnitRevenue", type: "string", isRequired: false },
      { name: "prizes", label: "Số giải thưởng", type: "number", isRequired: false },
      { name: "typeOfContractor", label: "Loại nhà thầu", type: "array select", selectData: toSelectData(contractor_type), isRequired: false },
      { name: "typeOfConstruction", label: "Loại công trình - Type of construction", type: "array select", selectData: toSelectData(contractor_construction_type), isRequired: false },
      { name: "typeOfProject", label: "Loại dự án", type: "array select", selectData: toSelectData(project_type), isRequired: false },
    ];
    return (
      <div className="animated fadeIn">
        {/* {this.renderMutipleImport()} */}
        <Card>
          <CardHeader>
            <i className="fa fa-envelope-open"></i> Create a contractor
              </CardHeader>
          <CardBody>
            <Row>
              <Col xs="12" md="6">
                <MakeForm
                  ref={ref => this.form1 = ref}
                  template={importTemp1}
                />
              </Col>
              <Col xs="12" md="6">
                <MakeForm
                  ref={ref => this.form2 = ref}
                  template={importTemp2}
                />
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button type="submit" size="sm" color="primary" onClick={() => this.form.onSubmit()}><i className="fa fa-dot-circle-o"></i> Save</Button>
            <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Cancel</Button>
          </CardFooter>
        </Card>
      </div>
    );
  }

  createContractor = async () => {
    const data = {...this.form1.getValue(), ...this.form2.getValue()};
    console.log(data);
    const { contractorStore } = this.props;
    let result = await contractorStore.create(data);
    if (!!result.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại   " + JSON.stringify(result.error));
    window.toast.info("Tạo nhà thầu thành công");
    this.setState({ contractor: {} });
    this.props.history.push("/contractors/list-not-approved");
  }
}

export default ImportContractors;


// WEBPACK FOOTER //
// ./src/views/Contractors/ImportContractors.js